import {Component, EventEmitter, OnInit} from '@angular/core';
import {UntypedFormControl, Validators} from '@angular/forms';
import {MDBModalRef} from 'ng-uikit-pro-standard';
import {IdAndLabel} from '../../../../common/model/id-and-label';
import {Localization} from '../../../../common/enums/localization';
import {take} from "rxjs/operators";
import {ChecklistNodeCheckpoint} from "../../checklist/model/checklist-node-checkpoint";
import {sortBy} from "../../../../../helpers/sorting";

@Component({
  templateUrl: './select-existing-checkpoint-modal.component.html',
  styleUrls: ['./select-existing-checkpoint-modal.component.scss']
})
export class SelectExistingCheckpointModalComponent implements SelectExistingCheckpointData, OnInit{

  private readonly selection$ = new EventEmitter<ChecklistNodeCheckpoint>();
  public readonly selection = this.selection$.pipe(take(1)).toPromise();

  public readonly Localization = Localization;
  public title: string;
  public checkpoints$: Promise<ChecklistNodeCheckpoint[]>;
  public checkpoints: ChecklistNodeCheckpoint[];

  public readonly selectionField = new UntypedFormControl(null, [Validators.required]);
  public checkpointOptions: IdAndLabel[];
  public loading = false;

  constructor(
    private readonly self: MDBModalRef,
  ) {
  }

  public get selectedCheckpoint() {
    return this.checkpoints.find(({id}) => this.selectionField.value === id);
  }

  public async ngOnInit() {
    await this.fetchCheckpoints();
    this.checkpointOptions = this.checkpoints
        .map(checkpoint => new IdAndLabel(checkpoint.id, checkpoint.checkPoint.label))
        .filter(option => !!option.label)
        .sort(sortBy('label'));
  }


  public close(){
    this.selection$.emit(null);
    this.self.hide();
  }

  public onSubmit(){
    this.selection$.emit(this.selectedCheckpoint);
    this.self.hide();
  }

  private async fetchCheckpoints() {
    this.loading = true;
    try {
      this.checkpoints = await this.checkpoints$;
    } finally {
      this.loading = false;
    }
  }
}

export interface SelectExistingCheckpointData {
  title: string;
  checkpoints$: Promise<ChecklistNodeCheckpoint[]>;
}